export default __webpack_public_path__ + "static/media/bosch.af79bc70.png";